import { render } from "./NcrmActivities.vue?vue&type=template&id=7bdfbb18&scoped=true"
import script from "./NcrmActivities.vue?vue&type=script&lang=js"
export * from "./NcrmActivities.vue?vue&type=script&lang=js"

import "./NcrmActivities.css?vue&type=style&index=0&id=7bdfbb18&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdfbb18"]])

export default __exports__